export const FILTER_MODAL = 'filter-modal';
export const FILTER_MODAL_TITLE = 'filter-modal-title';
export const FILTER_MODAL_FILTER_TYPES = 'filter-modal-filter-types';
export const FILTER_MODAL_ACTIVE_FILTER_TYPE = 'filter-modal-active-filter-types';
export const FILTER_MODAL_FILTER_TYPE_TITLE = 'filter-modal-filter-type-title';
export const FILTER_MODAL_CROSS_BUTTON = 'filter-modal-cross-button';
export const FILTER_MODAL_APPLY_BUTTON = 'filter-modal-apply-button';
export const FILTER_MODAL_CLEAR_ALL_BUTTON = 'filter-modal-clear-all-button';
// Nested Checkbox dataIds
export const FILTER_MODAL_COLLAPSE_WRAPPER = 'filter-modal-collapse-wrapper';
export const FILTER_MODAL_COLLAPSE_ITEM = 'filter-modal-collapse-item';
export const FILTER_MODAL_COLLAPSE_TITLE = 'filter-modal-collapse-title';
export const FILTER_MODAL_COLLAPSE_ARROW = 'filter-modal-collapse-arrow';
export const FILTER_MODAL_COLLAPSE_SELECT_ALL = 'filter-modal-collapse-select-all';
export const FILTER_MODAL_COLLAPSE_OPTION_L1 = 'filter-modal-collapse-option-l1';
export const FILTER_MODAL_COLLAPSE_GROUP_L2 = 'filter-modal-collapse-group-l2';
export const FILTER_MODAL_COLLAPSE_OPTION_L2 = 'filter-modal-collapse-option-l2';
// Checkbox dataIds
export const FILTER_MODAL_CHECKBOX_WRAPPER = 'filter-modal-checkbox-wrapper';
export const FILTER_MODAL_CHECKBOX_SELECT_ALL = 'filter-modal-checkbox-select-all';
export const FILTER_MODAL_CHECKBOX_OPTION = 'filter-modal-checkbox-option';
// InlineSearchSelect dataIds
export const FILTER_MODAL_AUTOCOMPLETE_WRAPPER = 'filter-modal-autocomplete-wrapper';
// Filter Chip dataIds
export const FILTER_CHIP_CONTAINER = 'filter-chip-container';
export const FILTER_CHIP_CROSS_ICON = 'filter-chip-cross-icon';
